"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOnlinePayment = exports.getUpToDateMetadata = exports.serializeForRefund = exports.getMaximumRefundableAmountForOnlinePayment = exports.getMaximumRefundableAmount = exports.getOriginalRefundTransaction = exports.handleRefundStatus = void 0;
const homi_shared_1 = require("@getgreenline/homi-shared");
const enums_1 = require("./enums");
const utils_1 = require("../payment/utils");
const BlazepayAPI_1 = require("../../../api/blazepay/BlazepayAPI");
const enums_2 = require("../payment/enums");
const handleRefundStatus = (response) => {
    switch (response.attributes.status) {
        case enums_1.RefundStatus.PENDING:
        case enums_1.RefundStatus.UNKNOWN:
            return;
        case enums_1.RefundStatus.REFUNDED:
            return;
        case enums_1.RefundStatus.FAILED:
            throw new Error(response.attributes.failReason || 'Refund failed');
        default:
            throw new Error('Refund status is not updated. Please check the terminal and try again.');
    }
};
exports.handleRefundStatus = handleRefundStatus;
const getOriginalRefundTransaction = (currentRefundPayment, originalPaymentTransactions, paymentTypeId) => {
    const provider = (0, utils_1.getProvider)(paymentTypeId);
    if (!provider)
        return;
    const currentRefundPaymentServiceTransactionIds = currentRefundPayment.transactions
        .filter((transaction) => transaction.paymentTypeId === paymentTypeId)
        .map((transaction) => { var _a; return (_a = (0, utils_1.parseTransactionFromMetadata)(transaction)) === null || _a === void 0 ? void 0 : _a.id; });
    return originalPaymentTransactions.find((transaction) => {
        const originalBlazeTransaction = (0, utils_1.parseTransactionFromMetadata)(transaction);
        if (!originalBlazeTransaction)
            return false;
        const isDuplicate = (originalBlazeTransaction === null || originalBlazeTransaction === void 0 ? void 0 : originalBlazeTransaction.id) &&
            currentRefundPaymentServiceTransactionIds.includes(originalBlazeTransaction === null || originalBlazeTransaction === void 0 ? void 0 : originalBlazeTransaction.id);
        return transaction.paymentTypeId === paymentTypeId && !isDuplicate;
    });
};
exports.getOriginalRefundTransaction = getOriginalRefundTransaction;
const getMaximumRefundableAmount = (transaction) => {
    var _a, _b;
    const originalTransaction = (0, utils_1.parseTransactionFromMetadata)(transaction);
    const chargedAmount = ((_a = originalTransaction === null || originalTransaction === void 0 ? void 0 : originalTransaction.attributes) === null || _a === void 0 ? void 0 : _a.chargedAmount) || 0;
    const tipAmount = ((_b = originalTransaction === null || originalTransaction === void 0 ? void 0 : originalTransaction.attributes) === null || _b === void 0 ? void 0 : _b.tipAmount) || 0;
    return chargedAmount - tipAmount || undefined;
};
exports.getMaximumRefundableAmount = getMaximumRefundableAmount;
const getMaximumRefundableAmountForOnlinePayment = (transaction) => {
    if (!transaction.metadata)
        return;
    const parsedTransactionMetadata = JSON.parse(transaction.metadata);
    const type = parsedTransactionMetadata === null || parsedTransactionMetadata === void 0 ? void 0 : parsedTransactionMetadata.type;
    if (!type)
        return;
    const attributes = parsedTransactionMetadata === null || parsedTransactionMetadata === void 0 ? void 0 : parsedTransactionMetadata.attributes;
    if (!attributes)
        return;
    const chargedAmount = attributes === null || attributes === void 0 ? void 0 : attributes.chargedAmount;
    const requestedAmount = attributes === null || attributes === void 0 ? void 0 : attributes.requestedAmount;
    if (!chargedAmount) {
        return requestedAmount || undefined;
    }
    const tipAmount = (attributes === null || attributes === void 0 ? void 0 : attributes.tipAmount) || 0;
    return chargedAmount - tipAmount;
};
exports.getMaximumRefundableAmountForOnlinePayment = getMaximumRefundableAmountForOnlinePayment;
const serializeForRefund = ({ paymentRes, refundRes, deviceId, currentUserId, reason, transaction, }) => {
    if (paymentRes) {
        const transactionAmount = Math.abs(transaction.amount);
        if (transactionAmount == null)
            throw new Error('Original transaction amount is not found');
        return {
            deviceId,
            transactionAmount,
            currentShiftId: currentUserId,
            paymentId: paymentRes.id,
            reason,
        };
    }
    else if (refundRes) {
        return {
            deviceId,
            transactionAmount: refundRes.attributes.requestedAmount,
            currentShiftId: currentUserId,
            paymentId: refundRes.attributes.paymentId,
            reason,
        };
    }
    else {
        throw new Error('Original payment not found. Please use a different refund method.');
    }
};
exports.serializeForRefund = serializeForRefund;
const getUpToDateMetadata = (merchantId, transaction, paymentOptions) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    if (!transaction.metadata) {
        return;
    }
    const parsedMetadata = JSON.parse(transaction.metadata);
    if (((_a = parsedMetadata === null || parsedMetadata === void 0 ? void 0 : parsedMetadata.attributes) === null || _a === void 0 ? void 0 : _a.status) === enums_2.PaymentStatus.CAPTURED) {
        return;
    }
    let provider;
    if (parsedMetadata === null || parsedMetadata === void 0 ? void 0 : parsedMetadata.paymentOptionId) {
        const paymentOption = paymentOptions.find((option) => option.id === (parsedMetadata === null || parsedMetadata === void 0 ? void 0 : parsedMetadata.paymentOptionId));
        provider = (_b = paymentOption === null || paymentOption === void 0 ? void 0 : paymentOption.attributes) === null || _b === void 0 ? void 0 : _b.provider;
    }
    else {
        provider = (0, utils_1.getProvider)(transaction.paymentTypeId);
    }
    if (!provider || !(parsedMetadata === null || parsedMetadata === void 0 ? void 0 : parsedMetadata.id)) {
        return;
    }
    const fetchRecentData = yield (0, BlazepayAPI_1.getSaleTransaction)({
        merchantId,
        providerName: provider,
        transactionId: parsedMetadata.id,
    });
    if (!fetchRecentData) {
        return;
    }
    const updatedMetadata = fetchRecentData.data;
    return JSON.stringify(updatedMetadata);
});
exports.getUpToDateMetadata = getUpToDateMetadata;
const isOnlinePayment = (transaction) => {
    if (transaction.paymentTypeId !== homi_shared_1.PaymentTypeIds.online)
        return false;
    return (0, utils_1.isPaymentServiceTransactionMetadata)(transaction);
};
exports.isOnlinePayment = isOnlinePayment;
//# sourceMappingURL=utils.js.map